import React, { useEffect, useState } from "react";
import "./AgencyProfileSteps.scss";
import classNames from "classnames";
import { CommonEnums } from "../../../enums/common.enums";
import { LocalStorageHelpers } from "../../../utils/helpers/localstorage.helpers";
import { clientRoutes } from "../../../utils/routes";
import TrueIcon from "../../../components/icons/TrueIcon";
import { IAgencyData } from "../../../@types/api-data.types";

const stepsOrder = [
  CommonEnums.agencyProfileSteps.agencyInfo,
  CommonEnums.agencyProfileSteps.verifyPhone,
  CommonEnums.agencyProfileSteps.legalInfo,
  CommonEnums.agencyProfileSteps.brandGrammer,
];

const AgentCreatingAgencySteps = (props: {
  step: string;
  agencyData: IAgencyData | null;
}) => {
  const agencyData: IAgencyData =
    props.agencyData || LocalStorageHelpers.getAgencyData() || {};

  const registrationStatus = agencyData?.registration_status;

  const isRejectedByAdmin =
    agencyData?.status === CommonEnums.status.rejected_by_admin;

  const stepsOrderToUse = isRejectedByAdmin
    ? [...stepsOrder, CommonEnums.agencyProfileSteps.agentInfo]
    : stepsOrder;

  const statusToStepMap: Record<string, string> = {
    [CommonEnums.agentRegistrationStatus.pending_for_agency_registration]:
      CommonEnums.agencyProfileSteps.agencyInfo,

    [CommonEnums.agentRegistrationStatus.phone_verification_is_pending]:
      CommonEnums.agencyProfileSteps.verifyPhone,

    [CommonEnums.agentRegistrationStatus.pending_for_legal_info]:
      CommonEnums.agencyProfileSteps.legalInfo,

    [CommonEnums.agentRegistrationStatus.pending_for_brand_grammar]:
      CommonEnums.agencyProfileSteps.brandGrammer,

    [CommonEnums.agentRegistrationStatus.pending_for_agent_info]:
      CommonEnums.agencyProfileSteps.agentInfo,

    [CommonEnums.agentRegistrationStatus.completed]: isRejectedByAdmin
      ? CommonEnums.agencyProfileSteps.agentInfo
      : CommonEnums.agencyProfileSteps.brandGrammer,
  };

  const activeStep = props.step;

  const completedStep =
    statusToStepMap[registrationStatus as string] ??
    CommonEnums.agencyProfileSteps.agencyInfo;

  const [state, setState] = useState({
    is_profile_completed: false,
    is_phone_verified: false,
  });

  useEffect(() => {
    const agencyInfo = LocalStorageHelpers.getAgencyData();

    setState({
      ...state,
      is_phone_verified: agencyInfo?.mobile_verification ?? false,
      is_profile_completed: agencyInfo?.is_profile_completed ?? false,
    });
  }, [activeStep]);

  // const agencyData: IAgencyData = LocalStorageHelpers.getAgencyData() || {};

  const isStepCompleted = (stepToCheck: string) => {
    switch (stepToCheck) {
      case CommonEnums.agencyProfileSteps.agencyInfo:
        return (
          !!agencyData?.principal_agent_first_name &&
          !!agencyData?.principal_agent_last_name &&
          !!agencyData?.email &&
          !!agencyData?.principal_agent_mobile_number &&
          !!agencyData?.phone_country_code &&
          !!agencyData?.street_name &&
          !!agencyData?.city &&
          !!agencyData?.state &&
          !!agencyData?.country &&
          !!agencyData?.post_code
        );
      case CommonEnums.agencyProfileSteps.verifyPhone:
        return !!agencyData?.mobile_verification;

      case CommonEnums.agencyProfileSteps.legalInfo:
        return (
          !!agencyData?.agency_trading_name &&
          !!agencyData?.agency_legal_name &&
          !!agencyData?.abn_number &&
          !!agencyData?.agency_type &&
          (agencyData?.agency_type !== "brand" || !!agencyData?.brand_id)
        );

      case CommonEnums.agencyProfileSteps.brandGrammer: {
        if (agencyData.agency_type === "independent") {
          return !!agencyData.profile_image || !!agencyData.profile_image_ref;
        }

        if (agencyData.agency_type === "brand") {
          if (agencyData.logo_preference === "office_logo") {
            return !!agencyData.profile_image || !!agencyData.profile_image_ref;
          }
          if (agencyData.logo_preference === "brand_logo") {
            return true;
          }
        }

        return false;
      }

      case CommonEnums.agencyProfileSteps.agentInfo: {
        const principalAgent = agencyData?.principal_agent_id as any;

        if (typeof principalAgent !== "object" || !principalAgent?._id) {
          return false;
        }

        const hasDesignation = !!principalAgent?.designation;
        const hasProfileImage =
          !!principalAgent?.profile_image ||
          !!principalAgent?.profile_image_ref;

        return hasDesignation && hasProfileImage;
      }

      default:
        return false;
    }
  };

  const getStepLink = (step: string) => {
    switch (step) {
      case CommonEnums.agencyProfileSteps.agencyInfo:
        return clientRoutes.agentCreateAgencyInfo;
      case CommonEnums.agencyProfileSteps.verifyPhone:
        return clientRoutes.agentCreateAgencyVerifyPhone;
      case CommonEnums.agencyProfileSteps.legalInfo:
        return clientRoutes.agentCreateAgencyLegalInfo;
      case CommonEnums.agencyProfileSteps.brandGrammer:
        return clientRoutes.agentCreateAgencyBrandGrammar;
      case CommonEnums.agencyProfileSteps.agentInfo:
        return clientRoutes.agentCreateAgencyAgentInfo;
      default:
        return "#";
    }
  };

  console.log("registrationStatus >>>", registrationStatus);
  console.log("completedStep >>>", completedStep);

  // const renderStep = (stepName: string, label: string) => {
  //   const isActive = stepName === activeStep;
  //   const isCompleted = isStepCompleted(stepName);

  //   const completedIndex = stepsOrder.indexOf(completedStep);
  //   const stepIndex = stepsOrder.indexOf(stepName);

  //   const isDisabled =
  //     stepIndex !== 0 && !isStepCompleted(stepsOrder[stepIndex - 1]);

  //   return (
  //     <a
  //       key={stepName}
  //       className={classNames("step-container", {
  //         "active-step": isActive,
  //         "completed-step": isCompleted,
  //         "disable-step": isDisabled,
  //       })}
  //       href={isDisabled ? "#" : getStepLink(stepName)}
  //     >
  //       {isCompleted && (
  //         <div className="icon-wrapper">
  //           <TrueIcon />
  //         </div>
  //       )}
  //       <span className="step-title">{label}</span>
  //     </a>
  //   );
  // };

  const renderStep = (stepName: string, label: string) => {
    const isActive = stepName === activeStep;
    const isCompleted = isStepCompleted(stepName);

    const completedIndex = stepsOrderToUse.indexOf(completedStep);
    const stepIndex = stepsOrderToUse.indexOf(stepName);

    const isDisabled =
      stepIndex > 0 && !isStepCompleted(stepsOrderToUse[stepIndex - 1]);

    return (
      <a
        key={stepName}
        className={classNames("step-container", {
          "active-step": isActive,
          "completed-step": isCompleted,
          "disable-step": isDisabled,
        })}
        href={isDisabled ? "#" : getStepLink(stepName)}
      >
        {isCompleted && (
          <div className="icon-wrapper">
            <TrueIcon />
          </div>
        )}
        <span className="step-title">{label}</span>
      </a>
    );
  };

  return (
    <div className="agency-profile-steps">
      <div className="logo-container">
        {/* <img
          src="/images/brand-bards-new-logo-with-background.png"
          alt="Brand Bards Logo"
        /> */}
        <img
          // src="/images/brand-bards-new-logo-with-background.png"
          src="/images/propertylogy_logo.svg"
          alt="Propertylogy Logo"
        />
      </div>

      <div className="header-content">
        <h2 className="font-lexend-deca-400">Set Up Your Agency Account</h2>
        <p className="sub-header">
          Just a few quick details to get your account registered and ready for
          work
        </p>
      </div>

      <div className="registration-steps-container">
        {renderStep(CommonEnums.agencyProfileSteps.agencyInfo, "Agency Basics")}
        {renderStep(CommonEnums.agencyProfileSteps.verifyPhone, "Verify Phone")}
        {renderStep(CommonEnums.agencyProfileSteps.legalInfo, "Legal Info")}
        {renderStep(
          CommonEnums.agencyProfileSteps.brandGrammer,
          "Brand Grammar",
        )}
        {isRejectedByAdmin &&
          renderStep(
            CommonEnums.agencyProfileSteps.agentInfo,
            "Principal Agent Info",
          )}
      </div>
    </div>
  );
};

export default AgentCreatingAgencySteps;
